import { isAfter, isBefore } from 'date-fns'
import { optionalStringSchema } from 'utils/zodHelpers'
import { z } from 'zod'

export const editUnitSchema = z
  .object({
    unitSlug: z.string(),
    name: z
      .string({ message: 'Name is required' })
      .min(1)
      .max(65, { message: 'Name must be less than 65 characters' }),
    builtDate: z.date().nullable(),
    description: z.string(),
    erpID: optionalStringSchema,
    area: optionalStringSchema,
    areaDescription: optionalStringSchema,
    retirementDate: z.date().nullable(),
  })
  .superRefine((data, ctx) => {
    if (
      data.builtDate !== null &&
      data.retirementDate !== null &&
      isAfter(data.builtDate, data.retirementDate)
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.invalid_date,
        path: ['builtDate'],
        message: 'Built date must be before retirement date',
      })
    }
    if (
      data.retirementDate !== null &&
      isBefore(data.retirementDate, new Date())
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.invalid_date,
        path: ['retirementDate'],
        message: 'Retirement date must be after today',
      })
    }
    if (
      data.retirementDate !== null &&
      data.builtDate !== null &&
      isBefore(data.retirementDate, data.builtDate)
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.invalid_date,
        path: ['retirementDate'],
        message: 'Retirement date must be after built date',
      })
    }
  })

export type EditUnitSchema = z.infer<typeof editUnitSchema>

export const defaultValues: EditUnitSchema = {
  unitSlug: '',
  name: '',
  builtDate: null,
  description: '',
  retirementDate: null,
  erpID: '',
  area: '',
  areaDescription: '',
}
